import punycode from 'punycode';
import { FILE_TYPES } from './constants';
/**
 * Returns the field value in a platform generic way.
 *
 * @param {Object | string} fieldParameter - The parameter passed through the change event function.
 * @returns {string}
 */
export function getFieldValue(fieldParameter) {
    return typeof fieldParameter === 'string' ? fieldParameter : fieldParameter?.target?.value;
}
/**
 * Formats the URL text for react-linkify.
 *
 * @param {string} text - The URL text.
 * @returns {string} - The formatted text.
 */
export function formatURLText(text = '') {
    let result;
    // In order to prevent homograph attacks we need to use punycode. Reference
    // https://github.com/tasti/react-linkify/issues/84. In the same time it seems PunycodeJS will treat the URL
    // as an email when there is '@' and will erase parts of it. This is problematic if there is a URL like
    // https://example.com/@test@@@123/test@test, punycode will truncate this to https://example.com/@test which
    // is security issue because parts of the URL are actually missing from the text that we display. That's why
    // we use punycode on valid URLs(that don't have '@' as part of the host) only for the host part of the URL.
    try {
        const url = new URL(text);
        const { host } = url;
        if (host) {
            url.host = punycode.toASCII(host);
            result = url.toString();
        }
    }
    catch (e) {
        // Not a valid URL
    }
    if (!result) {
        // This will be the case for invalid URLs or URLs without a host (emails for example). In this case beacuse
        // of the issue with PunycodeJS that truncates parts of the text when there is '@' we split the text by '@'
        // and use punycode for every separate part to prevent homograph attacks.
        result = text.split('@').map(punycode.toASCII)
            .join('@');
    }
    return result;
}
export function humanFileSize(bytes, si = false, dp = 1) {
    const thresh = si ? 1000 : 1024;
    if (Math.abs(bytes) < thresh) {
        return bytes + ' B';
    }
    const units = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let u = -1;
    const r = 10 ** dp;
    do {
        bytes /= thresh;
        ++u;
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);
    return bytes.toFixed(dp) + ' ' + units[u];
}
export function getFileType(fileName) {
    if (!fileName)
        return FILE_TYPES.FILE;
    let type = fileName.substring(fileName.lastIndexOf('.') + 1);
    switch (type.toLocaleLowerCase()) {
        case 'rar':
        case 'zip':
        case '7z':
            return FILE_TYPES.COMPRESS;
        case 'xlsx':
        case 'xls':
            return FILE_TYPES.EXCEL;
        case 'pdf':
            return FILE_TYPES.PDF;
        case 'doc':
        case 'docx':
            return FILE_TYPES.WORD;
        case 'ppt':
        case 'pptx':
            return FILE_TYPES.POWERPOINT;
        case 'txt':
            return FILE_TYPES.TEXT;
        default:
            return FILE_TYPES.FILE;
    }
}
;
